// No custom middleware in this widget.
// This stub satisfies the ws-scripts store.js static import('../middleware').
export default [];
